module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_2.2ae47f10.png";